import m from "../../geodata/es2015/indiaLow";
window.am4geodata_indiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/indiaLow.js
// module id = null
// module chunks = 